import Cookies from 'js-cookie'
import store from '@/store/index'
const ACCESS_TOKEN_KEY = 'TEAMPUP_PLAYONE_TOKEN'
const REFRESH_TOKEN_KEY = 'TEAMPUP_PLAYONE_REFRESH_TOKEN'

export function getToken() {
  return store.getters.token || Cookies.get(ACCESS_TOKEN_KEY)
}

export function getRefreshToken() {
  return store.getters.refreshToken || Cookies.get(REFRESH_TOKEN_KEY)
}

export function setToken(token, opts = {}) {
  return Cookies.set(ACCESS_TOKEN_KEY, token, opts)
}

export function setRefreshToken(refreshToken, opts = {}) {
  return Cookies.set(REFRESH_TOKEN_KEY, refreshToken, opts)
}

export function removeToken() {
  Cookies.remove(ACCESS_TOKEN_KEY)
  Cookies.remove(REFRESH_TOKEN_KEY)
}
